import React from 'react';

interface Props {
  message: string;
  onDismiss: () => void;
  size?: 'sm' | 'md';
  style?: React.CSSProperties;
}

const InlineErrorBanner: React.FC<Props> = ({ message, onDismiss, size = 'md', style }) => {
  const padded = size === 'sm' ? '6px 10px' : '8px 12px';
  return (
    <div role="alert" style={{ ...bannerBase, padding: padded, fontSize: size === 'sm' ? 12 : 12.5, ...style }}>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        type="button"
        onClick={onDismiss}
        style={dismissStyle}
        aria-label="Dismiss error"
      >
        ×
      </button>
    </div>
  );
};

const bannerBase: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  background: 'var(--danger-soft)',
  color: 'var(--danger)',
  border: '1px solid var(--cg-terra-200)',
  borderRadius: 6,
};

const dismissStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  fontSize: 16,
  lineHeight: 1,
  padding: '0 4px',
};

export default InlineErrorBanner;
